<script>
  // @ts-check
  import Accordion from "../../molecules/Accordion/Accordion.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** @typedef {import('./TimelineTypes').ScheduleProp} ScheduleProp */
  /** The Accordion props
   * @type {ScheduleProp[]} */
  export let schedules = [];
</script>

<div {id}>
  {#each schedules as schedule, index}
    {@const isLast = index === schedules.length - 1}
    <div class="override-item w-full border-b-thin {isLast ? '' : 'mb-15 xl:mb-30'}">
      <time datetime={schedule.datetime} class="heading-xs mb-6 block lg:mb-7.5 xl:mb-10"
        >{schedule.datetime}
      </time>
      <Accordion
        itemContainerClass="override-[item]:py-6 lg:override-[item]:py-8 xl:override-[item]:py-10"
        items={schedule.events}
        itemBodySlotClass="override-[item]:pt-6 lg:override-[item]:pt-8 xl:override-[item]:pt-10"
      />
    </div>
  {/each}
</div>
